var map = {
	"./contact/createItemInitialValue": 1031,
	"./cpo/createItemInitialValue": 364,
	"./customer/createItemInitialValue": 516,
	"./forwarderPo/createItemInitialValue": 365,
	"./incomingInvoice/createItemInitialValue": 366,
	"./incomingPayment/createItemInitialValue": 517,
	"./outgoingInvoice/createItemInitialValue": 367,
	"./outgoingPayment/createItemInitialValue": 518,
	"./outgoingQuote/createItemInitialValue": 368,
	"./product/createItemInitialValue": 519,
	"./receiving/createItemInitialValue": 369,
	"./shipping/createItemInitialValue": 370,
	"./spo/createItemInitialValue": 371,
	"./spoSched/createItemInitialValue": 372,
	"./vatDeductRecord/createItemInitialValue": 373,
	"./vendor/createItemInitialValue": 520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1030;